import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
  selector: 'app',
  template: '',
  hostDirectives: [
    RouterOutlet,
  ],
  imports: [
    RouterOutlet,
  ],
})
export class AppComponent { }
